import { createContext, useContext } from "react";
import useAxios from "../Utils/useAxios";
import {
  getItemSubmitSuccessMsg,
  getItemDeleteSuccessMsg,
} from "../Constant/Message";
import { handleError, handleSuccess } from "../Utils/externalFunctions";

const PengumumanContext = createContext();

export const usePengumuman = () => useContext(PengumumanContext);

export const PengumumanProvider = ({ children }) => {
  const axiosInstance = useAxios();

  const api = {
    getPengumuman: () =>
      axiosInstance
        .get("sipeg/pengumuman/")
        .catch((err) => handleError(err, "GET Pengumuman")),

    createPengumuman: (formData) =>
      axiosInstance
        .post("sipeg/pengumuman/", formData)
        .then((res) =>
          handleSuccess(res, getItemSubmitSuccessMsg("Pengumuman"))
        )
        .catch((err) => handleError(err, "CREATE Pengumuman")),

    updatePengumuman: (pk, formData) =>
      axiosInstance
        .put(`sipeg/pengumuman/${pk}`, formData)
        .then((res) =>
          handleSuccess(res, getItemSubmitSuccessMsg("Pengumuman"))
        )
        .catch((err) => handleError(err, "UPDATE Pengumuman")),

    deletePengumuman: (pk) =>
      axiosInstance
        .delete(`sipeg/pengumuman/${pk}`)
        .then((res) =>
          handleSuccess(res, getItemDeleteSuccessMsg("Pengumuman"))
        )
        .catch((err) => handleError(err, "DELETE Pengumuman")),
  };

  return (
    <PengumumanContext.Provider value={api}>
      {children}
    </PengumumanContext.Provider>
  );
};

export default PengumumanContext;
